import type { ScoringValueTone } from "@/lib/call-scoring-types";

type ScoreToneThresholds = {
  warningMin: number;
  successMin: number;
};

const DEFAULT_FIVE_POINT_THRESHOLDS: ScoreToneThresholds = {
  warningMin: 2,
  successMin: 4,
};

export function getScoreTone(
  score: number,
  thresholds: ScoreToneThresholds = DEFAULT_FIVE_POINT_THRESHOLDS,
): ScoringValueTone {
  if (!Number.isFinite(score)) return "neutral";
  if (score >= thresholds.successMin) return "success";
  if (score >= thresholds.warningMin) return "warning";
  return "danger";
}

export function getScoreToneUiClasses(score?: number) {
  const tone = getScoreTone(typeof score === "number" ? score : Number.NaN);

  if (tone === "success") {
    return {
      iconTextClassName: "text-success",
      iconBgClassName: "bg-success/10",
      valueTextClassName: "text-success",
      badgeClassName: "bg-success/10 text-success border-success/20",
      tone,
    };
  }

  if (tone === "warning") {
    return {
      iconTextClassName: "text-warning",
      iconBgClassName: "bg-warning/10",
      valueTextClassName: "text-warning",
      badgeClassName: "bg-warning/10 text-warning border-warning/20",
      tone,
    };
  }

  if (tone === "danger") {
    return {
      iconTextClassName: "text-danger",
      iconBgClassName: "bg-danger/10",
      valueTextClassName: "text-danger",
      badgeClassName: "bg-danger/10 text-danger border-danger/20",
      tone,
    };
  }

  return {
    iconTextClassName: "text-muted-foreground",
    iconBgClassName: "bg-muted/40",
    valueTextClassName: "text-muted-foreground",
    badgeClassName: "bg-muted/40 text-muted-foreground border-border",
    tone,
  };
}
